<template>
    <div class="app">
        <SignInPC v-if="isPC" />
        <SignInH5 v-else />
    </div>
</template>
<script>
    import SignInH5 from '../components/h5New';
    import SignInPC from '../components/pcNew';
    import { enableAppShare } from '../../../common/js/APP/share';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC
        },
        data() {
            return {};
        },
        mounted() {
            enableAppShare({
                title: '为什么大厂偏爱自动化测试？',
                desc: '领取完整技能体系，冲击名企翻倍薪资',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20210823/1629690765349.png',
            });
        }
    };
</script>
<style lang="less" scoped>
    .app {
        overflow-x: hidden;
    }
</style>
